import { apiFetch } from '@/lib/api';
import { bridgeSessionResponseSchema, type BridgeSession } from '@/schemas/factory-usb';

/**
 * Operator-side half of the agent authorization handshake (epic &167, #143, research &121 §4–5).
 *
 * This is the only part of the handshake that runs against the License Server: the code is minted
 * under the administrator's own session, exactly like every other `/factory-mode/*` call, and is
 * then handed over to the agent locally (`authorizeBridge` in `factory-bridge`). The loopback
 * bridge stays out of the operator API, and this module stays out of the bridge.
 */

/**
 * Mints a one-time authorization code for the current administrator (CONTRACT v0).
 *
 * The request carries no parameters — the session belongs to whoever is logged in — and the
 * response is parsed, never trusted: `session_id`, `one_time_code`, `expires_in_s`.
 */
export async function createBridgeSession(signal?: AbortSignal): Promise<BridgeSession> {
  const init: RequestInit = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  };
  if (signal) init.signal = signal;
  const res = await apiFetch('/factory-mode/bridge/session', init);
  return bridgeSessionResponseSchema.parse(await res.json());
}
